<template>
    <div class="entities-tab">
        <div class="entities-wrapper">
            <EntityEditor
                v-if="selectedEntity"
                :selectedEntity="selectedEntity"
                :isNewEntity="isNewEntity"
                @cancel="exitEditor"
            />

            <EntitiesList
                v-else
                :entities="allEntities.value"
                :loading="allEntities.loading"
                @edit="editEntity"
                @create="createNewEntity"
            />
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import EntitiesList from './list/EntitiesList'
import EntityEditor from './editors/EntityEditor'
import { getDefaultMlEntity } from './editors/ml-entity/ml-editor'
import { getDefaultRegexpEntity } from './editors/regexp-entity/RegexpEntity'
import { ENTITY_TYPE } from './entity-types'

export default {
  components: {
    EntitiesList,
    EntityEditor
  },

  data () {
    return {
      selectedEntity: null,
      isNewEntity: false
    }
  },

  computed: {
    ...mapState('knowledgebase/entities', ['allEntities'])
  },

  methods: {
    createNewEntity () {
      this.isNewEntity = true
      this.selectedEntity = getDefaultMlEntity()
    },

    editEntity (entity) {
      // Backward compatibility for old "simple" entities
      if (entity.type === ENTITY_TYPE.machineLearning) {
        this.selectedEntity = {
          ...getDefaultMlEntity(),
          ...entity
        }
      } else if (entity.type === ENTITY_TYPE.regexp) {
        this.selectedEntity = {
          ...getDefaultRegexpEntity(),
          ...entity
        }
      } else {
        this.selectedEntity = entity
      }
    },

    exitEditor () {
      this.isNewEntity = false
      this.selectedEntity = null
    }
  }
}
</script>

<style lang="scss" scoped>
    .entities-tab {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%;
        overflow-y: auto;
        .entities-wrapper {
            display: flex;
            height: 100%;
            flex-direction: column;
        }
    }
</style>
